import React from "react";
import { Modal } from "react-bootstrap";
import "../../styles/modals.scss";

const FormModal = (props) => (
  <Modal
    show={props.show}
    onHide={props.onHide}
    centered
    size={props.size || "lg"}
    backdrop={props.backdrop || "static"}
    animation={false}
    scrollable
  >
    <Modal.Header closeButton>
      <Modal.Title>{props.title}</Modal.Title>
    </Modal.Header>

    {props.children && <Modal.Body>{props.children}</Modal.Body>}
    {props.footer && <Modal.Footer>{props.footer}</Modal.Footer>}
  </Modal>
);

export default FormModal;
